<template>
  <div>
    <v-card class="px-3 pt-1 pb-3">
      <div class="text-xs-right">
        <v-btn flat icon color="primary" class="ma-0" @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <template v-if="order">
        <div :id="`order_${order.id}`" class="z-border-red" style="margin-bottom: 10px">
          <v-layout>
            <v-flex>
              <div class="ma-2">
                <span>Order No. {{ order.id }}</span>
              </div>
            </v-flex>
            <v-flex>
              <div class="ma-2" style="display: flex; justify-content: end; align-items: center">
                <template v-if="order.app == 'facebook'">
                  <em class="fab fa-facebook-square" style="color: #3c5a99; font-size: 25px" />
                </template>
                <template v-else-if="order.app == 'line'">
                  <em class="fab fa-line" style="color: #00c300; font-size: 25px" />
                </template>
              </div>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout wrap fill-height>
            <v-flex xs12 sm7>
              <div style="border-right: 1px solid #eee; height: 100%">
                <template v-if="typeof orderDetailFormat == 'string'">
                  <div class="pa-2">
                    <nl2br tag="div" :text="order.productdetail"></nl2br>
                  </div>
                </template>
                <template v-else-if="typeof orderDetailFormat == 'object'">
                  <template v-for="(product, oindex) in orderDetailFormat">
                    <v-layout :key="'order_' + oindex" wrap>
                      <v-flex sm1 xs2>
                        <div class="ma-2">
                          <v-img
                            :src="product.feature_img"
                            aspect-ratio="1"
                            alt
                            class="grey lighten-2"
                          >
                            <template #placeholder>
                              <v-layout fill-height align-center justify-center ma-0>
                                <!-- <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular> -->
                              </v-layout>
                            </template>
                          </v-img>
                        </div>
                      </v-flex>
                      <v-flex sm7 xs6 style="word-break: break-word">
                        <div class="ma-2">{{ product.title }} x {{ product.qty }}</div>
                      </v-flex>
                      <v-flex xs4 class="text-xs-right">
                        <div class="ma-2">฿{{ product.price | decimalFormat }}</div>
                      </v-flex>
                    </v-layout>

                    <v-divider
                      v-if="oindex < orderDetailFormat.length - 1"
                      :key="oindex"
                    ></v-divider>
                  </template>
                </template>

                <div>
                  <v-layout v-if="order.total != null">
                    <v-flex>
                      <div class="pa-2">{{ $t('Subtotal') }}:</div>
                    </v-flex>
                    <v-flex>
                      <div class="pa-2 text-xs-right">
                        <span class="primary-color">฿{{ order.total | decimalFormat }}</span>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="order.shippingcharge != null">
                    <v-flex>
                      <div class="pa-2">{{ $t('Shipping fee') }}:</div>
                    </v-flex>
                    <v-flex>
                      <div class="pa-2 text-xs-right">
                        <span class="primary-color"
                          >฿{{ order.shippingcharge | decimalFormat }}</span
                        >
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="order.discount > 0">
                    <v-flex>
                      <div class="pa-2">{{ $t('Discount') }}:</div>
                    </v-flex>
                    <v-flex>
                      <div class="pa-2 text-xs-right">
                        <span class="primary-color">-฿{{ order.discount | decimalFormat }}</span>
                      </div>
                    </v-flex>
                  </v-layout>

                  <v-layout v-if="jsonValue != null && jsonValue.promocode">
                    <v-flex>
                      <div class="pa-2">{{ $t('Coupon Code') }}:</div>
                    </v-flex>
                    <v-flex>
                      <div class="pa-2 text-xs-right">
                        <span class="primary-color">{{ jsonValue.promocode }}</span>
                      </div>
                    </v-flex>
                  </v-layout>

                  <v-layout v-if="order.amount != null">
                    <v-flex>
                      <div class="pa-2">{{ $t('Total') }}:</div>
                    </v-flex>
                    <v-flex>
                      <div class="pa-2 text-xs-right">
                        <span class="primary-color">฿{{ order.amount | decimalFormat }}</span>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 sm5>
              <div class="pa-2">
                <div class="mb-1">{{ order.social_name }}</div>
                <div>{{ order.nameaddress }}</div>
              </div>
              <v-divider></v-divider>
              <div class="pa-2">
                <div class="py-2">
                  อัพเดท : {{ order.order_updated_at | DateFormat('DD/MM/YYYY HH:mm') }}
                </div>
                <div class="py-1">
                  <v-chip color="grey lighten-3" label
                    >{{ $t('Order status') }}: {{ order.status || '-' }}</v-chip
                  >
                </div>
                <div class="py-1">
                  <v-chip color="grey lighten-3" label>
                    {{ $t('Tracking') }}: {{ order.trackingno || '-' }}</v-chip
                  >
                </div>
              </div>
            </v-flex>
            <v-flex xs12>
              <v-divider />
              <v-layout wrap>
                <v-flex class="pa-2">
                  <div class="caption">
                    {{ $t('Remark') }}
                  </div>
                  <div>
                    {{ order.remark || '-' }}
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </template>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['value'],
  data() {
    return {
      order: null,
      shippingValue: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    orderDetailFormat: {
      get() {
        let text = ''
        try {
          text = JSON.parse(this.order.productdetail)
        } catch (error) {
          text = this.order.productdetail
        }
        return text
      },
      set(value) {
        if (typeof value == String) {
          this.$set(this.order, 'productdetail', value)
        } else {
          this.$set(this.order, 'productdetail', JSON.stringify(value))
        }
      }
    },
    jsonValue() {
      try {
        if (this.order && this.order.jsonvalue) {
          return JSON.parse(this.order.jsonvalue)
        } else {
          return null
        }
      } catch (error) {
        return null
      }
    },
    shippingType() {
      return this.handleGetShippingType()
    }
  },
  watch: {
    order(newVal) {
      if (newVal) {
        this.shippingValue = this.handleGetShippingType()
      }
    }
  },
  mounted() {
    if (this.value) {
      this.order = this.value
    }
  },
  methods: {
    handleGetShippingType() {
      let shippingType = ''
      try {
        let jsondata = JSON.parse(this.order.shippingtype)

        shippingType = jsondata.type ? jsondata.type : ''
      } catch (error) {
        shippingType = this.order.shippingtype
      }
      let shippingValue = null
      try {
        if (typeof this.shippingOptions !== 'undefined' && this.shippingOptions) {
          shippingValue = this.shippingOptions.find((el) => {
            return el.name == shippingType || shippingType == el[4]
          })
        }
      } catch (error) {
        console.error(error)
      }
      return shippingValue
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/OrderStatistics/DialogOrderDetail.vue